import Showdown from 'showdown';

const converter = new Showdown.Converter({
  tables: true,
  literalMidWordUnderscores: true,
  simpleLineBreaks: true,
  disableForced4SpacesIndentedSublists: true,
});

/*
 * @description
 * 다음과 같은 예외 사항들을 커버하는 regex
 * <citation id="1,2,3,4,5"/> - 정상포맷
 * <citation id="1,2,3,4,5/> - 뒷 따옴표
 * <citation id='1,2,3,4,5'/> - 큰 따옴표 대신 작은 따옴표
 * <citation id=1,2,3,4,5 /> - 따옴표 전체 누락 + 공백
 * <citation id=1,2,3,4,5/> 따옴표 전체 누락
 */
const citationRegex = /<citation\s+id=["']?([^"'>/]+)["']?\s*\/>/g;
const citationStartPattern = /<citation[^>]*$/;

export const formatMessageWithCitations = (message: {
  text: string;
  message_id?: Alias;
  hideCitation?: boolean;
}) => {
  if (!message.text) return '';

  let text = message.text;

  const incompleteMatch = citationStartPattern.exec(text);
  if (incompleteMatch) {
    text = text.slice(0, incompleteMatch.index);
  }

  text = fixCitationTags(text);

  const textWithHtmlCitations = message.hideCitation
    ? text.replace(citationRegex, '')
    : text.replace(citationRegex, (match, ids) => {
        const idArray = ids.split(',').map((id: string) => id.trim());
        const citationText = `${idArray.length}`;
        return `<a href="#" class="citation" data-ids="${ids}" data-message-id="${message.message_id}">${citationText}</a>`;
      });

  const fullHtml = converter
    .makeHtml(textWithHtmlCitations)
    .replace(/<\/?p>/g, '<br>')
    .replace(/<li><br>/g, '<li>')
    .replace(/<br>\s*<\/li>/g, '</li>')
    .replace(/^(<br\s*\/?>\s*)+/i, '')
    .replaceAll('\\n', '');

  return fullHtml;
};

export const stripCitations = (text: string) => {
  const strippedText = text.replace(citationRegex, '');
  return strippedText;
};

export const fixCitationTags = (text: string) => {
  const pattern = new RegExp(
    String.raw`(<citation id=")([^\]/)]*)(/\]|/\)|\]|\))`,
    'g',
  );

  const replacement = '$1$2"/>';

  return text.replace(pattern, replacement);
};
